import { useEffect } from 'react'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    if (typeof window === 'undefined') return

    if (!window.fbq) {
      const n: any = function (...args: unknown[]) {
        if (n.callMethod) {
          n.callMethod.apply(n, args)
        } else {
          n.queue.push(args)
        }
      }
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      window.fbq = n
      window._fbq = n

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(script)
    }

    window.fbq?.('init', pixelId)
    window.fbq?.('track', 'PageView')

    const noscript = document.createElement('noscript')
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
    img.alt = ''
    noscript.appendChild(img)
    document.body.appendChild(noscript)

    return () => {
      noscript.remove()
    }
  }, [pixelId])
}
